// @flow

export const CONFIRM_EMAIL_SEND = 'CONFIRM_EMAIL_SEND'
export const CONFIRM_EMAIL_UPDATE = 'CONFIRM_EMAIL_UPDATE'
export const CONFIRM_EMAIL_ERROR = 'CONFIRM_EMAIL_ERROR'
